export default {
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.lgrpList,
					isDisabled: () => true
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpNm',
				minWidth: '120px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.sgrpAllList,
					isDisabled: () => true
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001215'), //항목
				prop: 'ipnPrvsSbc',
				minWidth: '350px'
			}
		];
	},
	getColumnsDetail_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpNm',
				minWidth: '90px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.lgrpList,
					isDisabled: () => true
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpNm',
				minWidth: '110px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.sgrpAllList,
					isDisabled: () => true
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001215'), //항목
				prop: 'ipnPrvsSbc',
				minWidth: '200px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001163'), //사용여부
				prop: 'useYn',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.useYnList
				}
			}
		];
	}
};
